import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引入按需注册vant组件导入语句
import '@/utils/vant-ui'
// 全局注册组件
import ArticleItem from '@/components/ArticleItem.vue'

// 注册组件
Vue.component('ArticleItem', ArticleItem)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
